import React, { useEffect } from 'react';

import { FilterGroup, OptionButton } from '@pkg/components/Filters';
import { type Collection } from '@pkg/graphql/codegen/graphql';
import { useAppSelector, useGetCollections } from '@pkg/hooks';

import { useNFTsFiltersStore } from '@app/store/zustand';
import { availableFilterSetMarketPlace } from '@app/store/zustand/profile-page/useNFTsFiltersStore';

import { CollectionFilterEntry } from '../CollectionFilterEntry';
import { Divider, FiltersList, OptionGrid } from '../FiltersSidebar/styles';

export function FiltersGroup() {
    const { availableFilters, setAvailableFilters } = useNFTsFiltersStore();
    const marketPlaceEnabled = useAppSelector((state) => state.featureFlags.features.marketplaceV1Enabled);

    useEffect(() => {
        if (marketPlaceEnabled) {
            setAvailableFilters(availableFilterSetMarketPlace);
        }
    }, [marketPlaceEnabled, setAvailableFilters]);

    const parsedFilter = availableFilters.parse;
    const filterKeys = Object.keys(parsedFilter).filter((key) => key !== 'collections');
    const collectionIds = availableFilters.get('collections');
    const { data: collections, isLoading: isLoadingCollections } = useGetCollections({
        variables: { idsOpt: collectionIds },
    });

    const filterMarkup = filterKeys.map((filterKey) => {
        const filterOptionKeys = parsedFilter[filterKey] as string[];
        return (
            <React.Fragment key={filterKey}>
                <FilterGroup label={filterKey} count={filterOptionKeys.length}>
                    <OptionGrid>
                        {filterOptionKeys.map((option) => {
                            return (
                                <OptionButton
                                    key={`${filterKey}-${option}`}
                                    filterKey={filterKey}
                                    filterOption={option}
                                />
                            );
                        })}
                    </OptionGrid>
                </FilterGroup>
                <Divider />
            </React.Fragment>
        );
    });

    const collectionFilterMarkup = collections?.length
        ? collections.map((collection: Collection) => (
              <CollectionFilterEntry key={collection.id} collectionData={collection} />
          ))
        : null;

    return (
        <FiltersList>
            {filterMarkup}
            {!isLoadingCollections && collections?.length ? (
                <FilterGroup label={'Collections'} count={collections.length}>
                    <OptionGrid>{collectionFilterMarkup}</OptionGrid>
                </FilterGroup>
            ) : null}
        </FiltersList>
    );
}
